
import axios from 'axios'
import { useOAuthStore } from '@/stores/oauth'
import {FileStorage_URL} from "@/interface/globalindex"

// 这个实例可以用来发送请求到文件存储服务
const FileStorageInstance = axios.create({
  baseURL: FileStorage_URL, // 根据你的 API 地址设置 baseURL
  timeout: 90000, // 设置请求超时（根据需要修改）
  withCredentials:true,
})

// 请求拦截器：在请求发送前加入 Authorization header
FileStorageInstance.interceptors.request.use(
  (config) => {
    const authStore = useOAuthStore()
    const token = authStore.token

    if (token) {
      // 如果 token 存在，添加 Authorization header
      if (config.headers) {
        config.headers['Authorization'] = `Bearer ${token}`
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export default FileStorageInstance